// src/contexts/Context/slices/useOrganizationSlice.js
import { useMemo } from "react";
import { useCorporateSlice } from "./Organization/useCorporateSlice";
import { useStructureSlice } from "./Organization/useStructureSlice";
import { useSupplyChainSlice } from "./Organization/useSupplyChainSlice";

export const useOrganizationSlice = () => {
  const supplyChainContext = useSupplyChainSlice();
  const structureContext = useStructureSlice();
  const corporateContext = useCorporateSlice();

  return useMemo(() => ({ ...supplyChainContext, ...structureContext, ...corporateContext }), [supplyChainContext, structureContext, corporateContext]);
};
